import { useExperimentTreatmentWithoutReporting } from '../experiments';

type UseIsInformationBarrierEnabled = () => boolean;
export const useIsInformationBarrierEnabled: UseIsInformationBarrierEnabled = () => {
  const isInformationBarrierEnabled = useExperimentTreatmentWithoutReporting('InformationBarriersPhase0') === true;

  return isInformationBarrierEnabled;
};
